<template>
  <b-card
    class="sa-card sa-card-border"
    header="Struttura - Presidio"
    header-tag="header"
    footer-tag="footer"
    title=""
  >
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label>Struttura</label>
        <b-form-select
          id="inline-form-custom-select-pref"
          v-model="localData.codiceStruttura"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="null"
          value-field="codiceStruttura"
          text-field="denominazione"
          :options="strutturaOptions"
          @change="onChangeStruttura"
          >
          <template #first>
            <b-form-select-option :value="null" disabled
              >- Seleziona -</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label>Presidi</label>
        <b-form-select
          id="inline-form-custom-select-pref"
          v-model="localData.idPresidio"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="null"
          value-field="id"
          text-field="denominazione"
          :options="presidiOptions"
          @change="onChangePresidio"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >- Seleziona -</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label>Regime</label>
        <b-form-select
          id="inline-form-custom-select-pref"
          v-model="localData.regime"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="''"
          value-field="codice"
          text-field="descrizione"
          :options="regimiOptions"
          @change="emitChange()"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >- Seleziona -</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label>Settings</label>
        <b-form-select
          id="inline-form-custom-select-pref"
          v-model="localData.settingCodice"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="''"
          value-field="codice"
          text-field="setting"
          :options="settingsPresidiOptions"
          @change="onChangeSettingCodice"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >- Seleziona -</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
  props: {
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {
        };
      },
    },
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  mixins: [UtilityMixin],
  data() {
    return {
      localData:{
        idPresidio:null,
        codiceStruttura:null,
        settingCodice:null,
        regime:null,
        settingDescrizione:null,
      },
      linkStrutture: "/strutture",
      strutturaOptions: [],
      linkPresidi: "/strutturepresidi",
      presidiOptions: [],
      linkRegimi: "/accettazioneregimi",
      regimiOptions: [],
      linkSettingPresidi: "/rsasettingspresidi",
      settingsPresidiOptions: [],
    };
  },
  mounted() {
    let me = this;
      if (this.jsonData) {
      this.localData = { ...this.jsonData };
    }
    me.loadStrutture();
    me.loadRegimi();
    if(me.localData.codiceStruttura){
        me.localData.idPresidio = null;
        me.strutturaOptions.forEach((element) => {
        if (element.codiceStruttura === me.localData.codiceStruttura) {
          me.loadPresidi(element.id);
        }
      });
    }
  },
  methods: {
        emitChange() {
          this.$emit('changeJsonData',{...this.localData});
    },
    loadStrutture() {
      let me = this;
      UtilityMixin.methods.loadDataResources(
        me.linkStrutture,
        null,
        me.loadStruttureSuccess,
        me.loadStruttureError
      );
    },
    loadStruttureSuccess(response) {
      let me = this;
      me.strutturaOptions = [];
      me.rows = response.data.data.recordsNumber;
      me.strutturaOptions = response.data.data;
      me.$emit("afterLoadData");
    },
    loadStruttureError(error) {
      let me = this;
      me.$emit("afterLoadData", error);
    },

    onChangeStruttura(value) {
      let me = this;
      me.localData.regime = null;
      me.localData.settingDescrizione = null;
      me.localData.settingCodice = null;
      me.localData.idPresidio = null;
      me.strutturaOptions.forEach((element) => {
        if (element.codiceStruttura === value) {
          me.loadPresidi(element.id);
        }
      });
      me.emitChange();
    },
    loadRegimi() {
      let me = this;
      UtilityMixin.methods.loadDataResources(
        me.linkRegimi,
        null,
        me.loadRegimiSuccess,
        me.loadRegimiError
      );
    },
    loadRegimiSuccess(response) {
      let me = this;
      me.regimiOptions = response.data.data.list;
    },
    loadRegimiError(error) {
      let me = this;
      me.$emit("afterLoadData", error);
    },
    loadPresidi(value) {
      let me = this;
      me.presidiOptions = [];
      UtilityMixin.methods.loadDataResources(
        me.linkPresidi,
        { idStruttura: value },
        me.resultLoadPresidiSuccess,
        me.resultLoadPresidiError
      );
    },
    resultLoadPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length === 1) {
        me.localData.idPresidio = me.presidiOptions[0].id;
        me.loadSettingsPresidi(me.localData.idPresidio);
      }
      this.$emit("afterLoadData");
    },
    resultLoadPresidiError(error) {
      this.$emit("afterLoadData", error);
    },

    loadSettingsPresidi(id) {
      let me = this;
      let params = { idPresidio: id };
      UtilityMixin.methods.loadDataResources(
        me.linkSettingPresidi,
        params,
        me.resultResponseSettings,
        me.resultErrorSettings
      );
    },
    resultResponseSettings(response) {
      let me = this;
      me.settingsPresidiOptions = response.data.data.list;
      if (me.settingsPresidiOptions.length === 1) {
        me.localData.settingCodice = me.settingsPresidiOptions[0].codice;
        me.localData.settingDescrizione = me.settingsPresidiOptions[0].setting;
      }
      me.emitChange()
    },
    resultErrorSettings(response) {
      UtilityMixin.methods.messaggeBoxError(this, response);
    },
    onChangeSettingCodice(value) {
      let me = this;
      me.settingsPresidiOptions.forEach((element) => {
        if (element.codice === value) {
          me.localData.settingDescrizione = element.setting;
          me.emitChange();
        }
      });
    },
    onChangePresidio(value) {
      let me = this;
      me.localData.regime = null;
      me.localData.settingDescrizione = null;
      me.localData.settingCodice = null;
      me.loadSettingsPresidi(value);
      me.emitChange();
    },

  },
};
</script>

<style lang="scss" scoped></style>
